export const PRICING = {
  basePriceCents: 2990,
  additionalPlushCents: 690,
  secondCopyCents: 1690,
  currency: 'EUR' as const,
  maxPlushiesPerBook: 3,
} as const;

export function formatEuro(cents: number): string {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(cents / 100);
}
